import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';
import { v4 as uuidv4 } from 'uuid';

const USER_ID_KEY = 'braincheck_user_id';
const IS_LOGGED_IN_KEY = 'braincheck_is_logged_in';

// 1. 세션/로컬 통합 조회
export const getUserId = (): string | null => {
  // 로그인이 되어있다면 로컬에서, 아니면 세션에서 가져옴
  return localStorage.getItem(USER_ID_KEY) || sessionStorage.getItem(USER_ID_KEY);
};

// 2. 로그인 여부에 따라 저장 위치 변경
export const setUserId = (userId: string, isLoggedIn: boolean = false): void => {
  if (isLoggedIn) {
    localStorage.setItem(USER_ID_KEY, userId);
    localStorage.setItem(IS_LOGGED_IN_KEY, 'true');
    sessionStorage.removeItem(USER_ID_KEY); 
  } else {
    sessionStorage.setItem(USER_ID_KEY, userId);
    localStorage.removeItem(USER_ID_KEY);
    localStorage.removeItem(IS_LOGGED_IN_KEY);
  }
};

export const checkIfLoggedIn = (): boolean => {
  return localStorage.getItem(IS_LOGGED_IN_KEY) === 'true';
};

export const clearUserId = (): void => {
  localStorage.removeItem(USER_ID_KEY);
  localStorage.removeItem(IS_LOGGED_IN_KEY);
  sessionStorage.removeItem(USER_ID_KEY);
  sessionStorage.removeItem('braincheck_test_set_id');
};

export const generateUserId = (): string => {
  return uuidv4();
};

// ID 보장 및 초기화 로직
export const ensureUserId = async (): Promise<string> => {
  let userId = getUserId(); 

  if (!userId) {
    userId = generateUserId();
    try {
      const userRef = doc(db, 'users', userId);
      // 신규 유저 등록
      await setDoc(userRef, {
        id: userId,
        createdAt: new Date(),
        lastVisited: new Date()
      });
      // 초기 상태는 비회원 세션으로 설정
      sessionStorage.setItem(USER_ID_KEY, userId);
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  } else {
    // 기존 유저인 경우 방문 시간만 업데이트
    try {
      const userRef = doc(db, 'users', userId);
      await setDoc(userRef, { lastVisited: new Date() }, { merge: true });
    } catch (error) {
      console.error('Error updating user last visit:', error);
    }
  }
  return userId;
};

// 사용자 데이터 가져오기
export const getUserData = async (userId: string) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists()) {
      return userDoc.data();
    }
    return null;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}; 